export default function InventoryFormSection({ children, title }) {
    return (
        <div className="mb-3 px-2">
            <h4>{title}</h4>
            <hr />
            {children}
        </div>
    )
}